import(/* webpackMode: "eager" */ "/tmp/build-6a709b458295d50014964ce6/src/app/about/page.tsx");
